// StaffLimitBadge.jsx — 직원 관리 머리글 "인원 n / 한도" (2026-10-25 요금제 4-3)
//   인원 = 그 테넌트의 재직 계정 전부(직원·마케터·외부직원·테넌트 관리자). 한도가 있는 손님 테넌트에서만 보인다.
//   서버 `${apiBase}/staff-limit` — 직원 목록과 같은 문지기. 목록이 바뀌면(listKey·marketerKey) 다시 읽는다.
import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';

export default function StaffLimitBadge({ apiBase, listKey, marketerKey }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    apiClient.get(`${apiBase}/staff-limit`)
      .then((res) => { if (alive) setInfo(res.ok ? res.data?.data || null : null); })
      .catch(() => { if (alive) setInfo(null); });
    return () => { alive = false; };
  }, [apiBase, listKey, marketerKey]);

  if (!info?.limit) return null;
  const full = info.count >= info.limit;
  return (
    <span
      title="직원·마케터·외부직원·테넌트 관리자를 모두 셉니다"
      style={{ marginLeft: 8, fontWeight: 700, color: full ? '#dc2626' : 'var(--text-muted)', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}
    >
      · 인원 {info.count} / {info.limit}명{full ? ' — 다 찼어요' : ''}
    </span>
  );
}
